import * as types from './types'

export const addNote = (payload: any) => ({
  type: types.ADD_NOTE,
  payload,
})
export const getNotesByContract = (payload: any) => ({
  type: types.GET_NOTES_BY_CONTRACT,
  payload,
})
export const editNote = (payload: any) => ({
  type: types.EDIT_NOTE,
  payload,
})

export const setNull = (payload: any) => ({
  type: types.SET_NULL,
  payload,
})

export const deleteNote = (payload: any) => ({
  type: types.DELETE_NOTE,
  payload,
})
